
import 'pages/persons/persons-list-select-modal.tag'
import './permissions-roles-list-modal.tag'
riot.tag2('permissions-users', '  <catalog object="PermissionUser" cols="{cols}" add="{add}" remove="{remove}" reload="true" store="permissions-users" dblclick="{edit}">\n    <yield to="head">\n      <button class="btn btn-success" if="{selectedCount &gt; 1}" type="button" onclick="{parent.edit}"><i class="fa fa-group"></i></button>\n    </yield>\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="regDate">{row.regDate}</datatable-cell>\n      <datatable-cell name="login">{row.login}</datatable-cell>\n      <datatable-cell name="lastName">{[row.firstName, row.secondName, row.lastName].join(\' \').trim()}</datatable-cell>\n      <datatable-cell name="roles">{row.roles}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('remove');
self.collection = 'PermissionUser';

self.cols = [{ name: 'id', value: '#' }, { name: 'regDate', value: 'Дата. рег.' }, { name: 'login', value: 'Логин' }, { name: 'lastName', value: 'Ф.И.О.' }, { name: 'roles', value: 'Роли' }];

self.add = function () {
    modals.create('persons-list-select-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            var items = _this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length) {
                var ids = items.map(function (i) {
                    return i.id;
                });
                API.request({
                    object: 'PermissionUser',
                    method: 'Save',
                    data: { ids: ids },
                    success: function success(response) {
                        self.tags.catalog.reload();
                        _this.modalHide();
                    }
                });
            }
        }
    });
};

self.edit = function (e) {
    var ids = void 0;

    if (e.item) {
        ids = [e.item.row.id];
    } else {
        ids = self.tags.catalog.tags.datatable.getSelectedRows().map(function (i) {
            return i.id;
        });
    }

    modals.create('permissions-roles-list-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            var items = _this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length) {
                var idsRoles = items.map(function (i) {
                    return i.id;
                });
                API.request({
                    object: 'PermissionUser',
                    method: 'Save',
                    data: { ids: ids, idsRoles: idsRoles },
                    success: function success(response) {
                        self.tags.catalog.reload();
                        _this.modalHide();
                    }
                });
            }
        }
    });
};
});


// WEBPACK FOOTER //
// ./pages/settings/permissions/permissions-users.tag